/**
 * Child Groups
 */

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ColorBlock from 'components/media/ColorBlock/index.js';

const Wrapper = styled.div`
display: flex;
align-items: baseline;
  & > * + * {
    margin-left: 0.3rem;
  }
`;

function ChildGroups(props) {
  const { group } = props;
  const { childGroups } = group;
  if (!childGroups || childGroups.length === 0) {
    return null;
  }
  return (
    <Wrapper>
      {childGroups.map((g) => (
        <ColorBlock key={g.id} color={g.theme.themeColor} />
      ))}
    </Wrapper>
  );
}

ChildGroups.propTypes = {
  group: PropTypes.object,
};

export default ChildGroups;
